// extracted by mini-css-extract-plugin
export default {"container":"PilIc5","item":"CvDwmJ"};